// El backend envía fechas en formato DATE_ATOM ("2026-07-23T08:00:00-03:00"), por lo que no se
// pueden parsear partiendo el string: hay que resolverlas como Date y renderizarlas en hora local.

const pad = (value: number) => String(value).padStart(2, "0");

const parse = (iso: string): Date | null => {
  if (!iso) return null;
  const date = new Date(iso);
  return isNaN(date.getTime()) ? null : date;
};

/** "2026-07-23T08:00:00-03:00" -> "23/07" */
export const formatDateShort = (iso: string): string => {
  const date = parse(iso);
  if (!date) return "";
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}`;
};

/** "2026-07-23T08:00:00-03:00" -> "23/07 08:00" */
export const formatDateTimeShort = (iso: string): string => {
  const date = parse(iso);
  if (!date) return "";
  return `${formatDateShort(iso)} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

/**
 * Prefiere el timestamp numérico (en segundos) y cae al parseo del string ATOM.
 * Devuelve NaN si no hay ninguno de los dos, para que el llamador decida.
 */
export const toTimestampMs = (timestamp: number | null | undefined, iso: string): number => {
  if (typeof timestamp === "number" && !isNaN(timestamp)) {
    return timestamp * 1000;
  }
  const date = parse(iso);
  return date ? date.getTime() : NaN;
};

/**
 * Vigencia de una autorización. Un extremo que no se puede resolver se trata como abierto,
 * así una autorización válida nunca queda bloqueada por datos incompletos.
 */
export const isWithinRange = (
  beginTimestamp: number | null | undefined,
  endTimestamp: number | null | undefined,
  beginIso: string,
  endIso: string,
  now: number = Date.now()
): boolean => {
  const begin = toTimestampMs(beginTimestamp, beginIso);
  const end = toTimestampMs(endTimestamp, endIso);
  if (!isNaN(begin) && now < begin) return false;
  if (!isNaN(end) && now > end) return false;
  return true;
};
